import { useTranslation } from "react-i18next";
import { Col, Form, Row } from "react-bootstrap";
import { SurveyQuestion } from "../../../types";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../redux/store";

interface SurveyQuestionAnswerProps {
    index: number;
    updateQuestionField: (index: number, field: keyof SurveyQuestion, value: any) => void; 
}

export default function SurveyQuestionAnswerText({ index, updateQuestionField }: SurveyQuestionAnswerProps) {
    const { t } = useTranslation(['surveyAdmin', 'common']);
    const question = useSelector((state: RootState) => state.surveyForm.data.questions[index]);

    return (
        <Row>
            <Col md={9}>
                <Row>
                    <Col md={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("surveyAdmin:dafaultValue")}</Form.Label>
                            <Form.Control
                                value={question.textDefaultValue ?? ""}
                                onChange={(e) => updateQuestionField(index, 'textDefaultValue', e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>{t("surveyAdmin:maximumNumberOfCharacters")}</Form.Label>
                            <Form.Control
                                type="number"
                                min="0"
                                value={question.maximumNumberOfCharacters ?? ""}
                                onChange={(e) => updateQuestionField(index, 'maximumNumberOfCharacters', e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}